import './index.scss'
import '../../assets/scripts/countNumber.js'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/jquery.fittext.js'
import '../../assets/scripts/jquery.lettering.js'
import '../../assets/scripts/jquery.textillate.js'

function numScroll() {
  $(".number .num").each(function(){
    let num = $(this).attr('data-num')
    $(this).rollNum({
      deVal: num
    });
  })
}

$(document).ready(function(){
  $('.ny-banner h1').textillate();
  if($('.ny-banner h2').html() != ''){
    setTimeout(function(){
      $('.ny-banner h2').textillate();
    },800)
  }
  var swiper1 = new Swiper(".section6 .mySwiper", {
    effect : 'fade',
    autoHeight: true,
    fadeEffect: {
      crossFade: true,
    },
    allowTouchMove: false,
    on:{
      init: function(swiper){
        $('.section6 .swiper-tab>div').eq(this.realIndex).addClass('active')
      },
      slideChangeTransitionStart: function(){
        $('.section6 .swiper-tab>div').eq(this.realIndex).addClass('active').siblings().removeClass('active')
      },
    }
  })
  $('.section6 .swiper-tab>div').on('click',function(){
    let index = $(this).index()
    swiper1.slideTo(index)
  })
})

$(document).scroll(function () {
  let scroH = $(document).scrollTop(); //滚动高度
  let viewH = $(window).height(); //可见高度
  let numTop = $('.section6 .number-c').offset().top - viewH

  if(scroH > numTop){
    numScroll()
  }else{
    $(".number .num").each(function(){
      let num = $(this).attr('data-num')
      $(this).html(num);
    })
  }
})